import { FunctionComponent as F } from "react";
import Box from '@mui/material/Box';
import loadingGif from '../../../../images/loading.gif';


const LoadingGifSmall: F = () =>
{
  return (
    <Box sx={{ width: '22px', height: '22px', overflow: 'hidden' }}>
      <img src={loadingGif} style={{
        width: 70,
        height: 70,
        marginLeft: -20.5,
        marginTop: -24 }}/>
    </Box>);
};

export default LoadingGifSmall;
